import { useState } from "react";
import { day } from "../api.js";
import { useResource } from "./useResource.js";

// «Довідник показників»: мінімальна зарплата, ставки податків із зарплати, пороги СМКОР, строки реєстрації ПН —
// значення на дату, період дії і джерело. Значення змінюються лише після перевірки джерела (lib/ref-params.js)
const fmt = (v, unit) => {
  const n = Number(v).toLocaleString("uk-UA");
  return unit === "грн" ? `${n} грн` : unit === "%" ? `${n} %` : `${n} ${unit}`;
};
const span = (p) => `${p.to ? "" : "з "}${day(p.from)}${p.to ? ` – ${day(p.to)}` : ""}`;

function Source({ s }) {
  if (!s) return null;
  return (
    <span className="muted small">
      {s.url ? <a href={s.url} target="_blank" rel="noopener">{s.title}</a> : s.title}
      {s.edition ? `, ${s.edition}` : ""}{s.note ? `. ${s.note}` : ""}
    </span>
  );
}

export default function RefParams() {
  const [date, setDate] = useState("");
  const r = useResource(`/api/ref/params${date ? `?date=${date}` : ""}`);
  return (
    <>
      <div className="section-head"><div className="section-title"><h2>Довідник показників</h2>
        <p className="status">Мінімальна зарплата, ставки податків із зарплати, пороги СМКОР і строки реєстрації ПН — з періодами дії та джерелами</p></div></div>
      <section className="card refp">
        <div className="row refp-head">
          <label className="field field-inline">Значення на дату
            <input type="date" value={date || r.data?.date || ""} onChange={(e) => setDate(e.target.value)} /></label>
          {date && <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDate("")}>Сьогодні</button>}
        </div>
        <p className="notice small" role="note"><b>Заплановано:</b> внесення змін у довідник з інтерфейсу — нове значення з періодом дії, джерелом і редакцією документа, з перевіркою перед застосуванням та історією змін. Поки значення змінюються лише в коді (lib/ref-params.js).</p>
        <p className="muted small">Значення вносимо лише після перевірки офіційного джерела; на дату поза відомими періодами показник — «невідомо», а розрахунки позначають припущення.</p>
        {r.error && <p className="error">{r.error.message}</p>}
        {r.pending && <p className="muted">Завантажуємо…</p>}
        {r.data?.groups.map((g) => (
          <div key={g.key} className="refp-group">
            <h3>{g.title}</h3>
            <ul className="refp-list">{g.params.map((p) => (
              <li key={p.code} className={p.current ? "" : "unknown"}>
                <div className="refp-main">
                  <span className="refp-title">{p.title}</span>
                  <b className="refp-val">{p.current ? fmt(p.current.value, p.unit) : "невідомо"}</b>
                </div>
                <p className="small">
                  {p.current ? <>Діє {span(p.current)}. <Source s={p.current.source} /></>
                    : p.lastKnown ? <>Останнє відоме — {fmt(p.lastKnown.value, p.unit)} ({span(p.lastKnown)}); на цю дату значення ще не встановлене.</> : "Значення на цю дату в довідник не внесено."}
                </p>
                {p.note && <p className="muted small">{p.note}</p>}
                <details className="small">
                  <summary>Історія і де використовується</summary>
                  <ul className="refp-hist">{p.periods.map((x, i) => (
                    <li key={i}><b>{fmt(x.value, p.unit)}</b> — {span(x)}; <Source s={x.source} /> <span className="muted">перевірено {day(x.checked)}</span></li>
                  ))}</ul>
                  <p className="muted">Використовується: {p.used.join(", ")}. Код: <code>{p.code}</code></p>
                </details>
              </li>
            ))}</ul>
          </div>
        ))}
      </section>
    </>
  );
}
